import '../component/Sidebar/Sidebar.css'
import {AdminRoles} from "../context/reducer";
import OccasionalBanner from "../pages/occasionalBanner/OccasionalBanner";
import LanguageSetting from "../pages/languageSetting/LanguageSetting";
import MawkibRegistrationLicense from "../pages/mawkibRegistrationLicense/MawkibRegistrationLicense";
import MawakibLocationDetails from "../pages/mawakibLocationDetails/MawakibLocationDetails";
import CompleteRegistration from "../pages/completeRegistration/CompleteRegistration";
import Campaigns from "../pages/campaigns/Campaigns";
import GameRegistration from "../pages/gameRegistration/GameRegistration";

export const RouteHelper = {
    Root: {
        key: "ROOT",
        url: "/",
        globalUrl: "/panel/",
        name: "داشبورد",
        icon: 'ic-game-play',
        accessRole: []
    },
    Dashboard: {
        key: "DASHBOARD",
        url: "dashboard",
        globalUrl: "/panel/dashboard",
        name: "داشبورد",
        icon: 'ic-dashboard',
        accessRole: []
    },
    Magazine: {
        key: "MAGAZINE",
        name: "مجله",
        icon: 'ic-magazine',
        accessRole: [
            AdminRoles.READ_POSTS_LIST.role,
            AdminRoles.READ_POST_CATEGORY_TREE.role,
            AdminRoles.READ_TAGS_OFFERS.role,
            AdminRoles.READ_FILES_LIST.role,
        ]
    },
    MagazineList: {
        key: "MAGAZINE_LIST",
        url: "magazine",
        globalUrl: "/panel/magazine",
        name: "آخرین مطالب",
        icon: 'ic-game-play',
        accessRole: [
            AdminRoles.READ_POSTS_LIST.role
        ]
    },
    MagazineCategory: {
        key: "MAGAZINE_CATEGORY",
        url: "magazine-category",
        globalUrl: "/panel/magazine-category",
        name: "دسته بندی",
        icon: "ic-menu",
        accessRole: [
            AdminRoles.READ_POST_CATEGORY_TREE.role
        ]
    },
    TagList: {
        key: "MAGAZINE_TAGS",
        url: "magazine-tags",
        globalUrl: "/panel/magazine-tags",
        name: "تگ ها",
        icon: "ic-game-play",
        accessRole: [
            AdminRoles.READ_TAGS_OFFERS.role
        ]
    },
    FileManager: {
        key: "FILE_MANAGER",
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.READ_FILES_LIST.role]
    },
    MagazineWriters: {
        key: "MAGAZINE_WRITERS",
        url: "magazine-writers",
        globalUrl: "/panel/magazine-writers",
        name: "نویسنده ها",
        icon: "ic-menu",
        accessRole: [
            AdminRoles.READ_POSTS_LIST.role
        ]
    },
    MagazineWriterDetail: {
        key: "MAGAZINE_WRITERS",
        url: "magazine-writers/:id",
        globalUrl: "/panel/magazine-writers/:id",
        name: "جزئیات نویسنده",
        icon: "ic-menu",
        accessRole: [
            // AdminRoles.READ_POST_WRITER_INFORMATION.role
        ]
    },
    Store: {
        key: "STORE",
        name: "فروشگاه",
        icon: "ic-store",
        accessRole: [
            AdminRoles.READ_ADMINS_LIST.role
        ]
    },
    Products: {
        key: "PRODUCTS",
        url: "products",
        globalUrl: "/panel/products",
        name: "محصولات",
        icon: "ic-store",
        accessRole: []
    },
    ProductDetails: {
        key: "PRODUCT_DETAILS",
        url: "product-details/:id",
        globalUrl: "/panel/product-details/:id",
        name: "جزئیات محصول",
        icon: "ic-menu",
        accessRole: []
    },
    ProductVariant: {
        key: "PRODUCT_VARIANT",
        url: "product-variant",
        globalUrl: "/panel/product-variant",
        name: "انواع محصول",
        icon: "ic-menu",
        accessRole: []
    },
    ProductVariantDetails: {
        key: "PRODUCT_VARIANT_DETAILS",
        url: "product-variant-details/:id",
        globalUrl: "/panel/product-variant-details/:id",
        name: "جزئیات نوع محصول",
        icon: "ic-menu",
        accessRole: []
    },
    MemorialNote: {
        key: "MEMORIAL_NOTE",
        name: "دلنوشته",
        icon: 'ic-heart',
        accessRole: []
    },
    MemorialNotes: {
        key: "MEMORIAL_NOTES",
        url: "memorial-notes",
        globalUrl: "/panel/memorial-notes",
        name: "دلنوشته ها",
        icon: "",
        accessRole: [AdminRoles.READ_MEMORIAL_NOTES_LIST.role]
    },
    MemorialNoteDetails: {
        key: "MEMORIAL_NOTE_DETAILS",
        url: "memorial-note-details/:id",
        globalUrl: "/panel/memorial-note-details/:id",
        name: "جزئیات دلنوشته",
        icon: "",
        accessRole: []
    },
    Managers: {
        id: "Managers",
        name: "مدیران",
        icon: "ic-managers",
        accessRole: [AdminRoles.READ_ADMINS_LIST.role, AdminRoles.CREATE_ADMIN_ROLE.role]
    },
    ManagersDetail: {
        key: "MANAGERS_DETAILS",
        url: "managers-detail/:id",
        globalUrl: "/panel/managers-detail/:id",
        name: "جزئيات مدیر",
        icon: "ic-game-play",
        accessRole: [AdminRoles.READ_ADMINS_LIST.role]
    },
    ManagersList: {
        key: "MANAGER_LIST",
        url: "managers",
        globalUrl: "/panel/managers",
        name: "لیست مدیران",
        icon: "ic-residence",
        accessRole: [AdminRoles.READ_ADMINS_LIST.role]
    },

    MagazineDetail: {
        key: "MAGAZINE_DETAIL",
        url: "magazine/:id",
        globalUrl: "/panel/magazine/:id",
        name: "جزئیات مقاله",
        icon: "ic-game-play",
        accessRole: [AdminRoles.READ_ADMINS_LIST.role]
    },
    ManagersAccess: {
        key: "MANAGER_ACCESS",
        url: "managers/managers-access",
        globalUrl: "/panel/managers/managers-access",
        name: "سطح دسترسی",
        icon: "ic-access-level",
        accessRole: [AdminRoles.CREATE_ADMIN_ROLE.role]
    },
    ManagersAccessDetail: {
        key: "MANAGER_ACCESS_DETAILS",
        url: "managers-access/:id",
        globalUrl: "/panel/managers-access/:id",
        name: "سطح دسترسی",
        icon: "ic-access-level",
        accessRole: []
    },
    FAQ: {
        key: "FAQ",
        name: "سوالات متداول",
        icon: 'ic-question',
        accessRole: []
    },
    FaqList: {
        key: "FAQ_LIST",
        name: "سوالات متداول",
        url: "faq_list",
        globalUrl: "/panel/faq_list",
        icon: "ic-question",
        accessRole: []
    },
    TourFileManager: {
        key: "TOUR_FILE_MANAGER",
        url: "tour-file-manager",
        globalUrl: "/panel/tour-file-manager",
        name: "فایل ها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.READ_FILES_LIST.role]
    },
    PaymentGateway: {
        key: "PAYMENT_GATEWAY",
        name: "امور مالی",
        icon: 'ic-transactions',
        accessRole: [AdminRoles.READ_PAYMENT_GATEWAYS_LIST.role, AdminRoles.READ_PAYMENT_TRANSACTIONS_LIST.role]
    },
    PaymentGatewaysList: {
        key: "PAYMENT_GATEWAYS_LIST",
        name: "درگاه های پرداخت",
        url: "payment-gateways",
        globalUrl: "/panel/payment_gateways",
        icon: "ic-question",
        accessRole: [AdminRoles.READ_PAYMENT_GATEWAYS_LIST.role]
    },
    PaymentGatewaysInformation: {
        key: "PAYMENT_GATEWAYS_LIST",
        name: "اطلاعات درگاه پرداخت",
        url: "payment-gateways/:id",
        globalUrl: "/panel/payment-gateways/:id",
        icon: "ic-question",
        accessRole: []
    },
    TransactionsList: {
        key: "TRANSACTIONS_LIST",
        name: "سابقه تراکنشات",
        url: "transactions",
        globalUrl: "/panel/transactions",
        icon: "ic-question",
        accessRole: [AdminRoles.READ_PAYMENT_TRANSACTIONS_LIST.role]
    },
    TransactionDetail: {
        key: "TRANSACTION_DETAIL",
        name: "جزئیات تراکنش",
        url: "transactions/:id",
        globalUrl: "/panel/transactions/:id",
        icon: "",
        accessRole: []
    },
    Users: {
        key: "USERS",
        name: "کاربران",
        icon: 'ic-users',
        accessRole: [AdminRoles.READ_USERS_LIST.role]
    },
    UsersList: {
        key: "USERS_LIST",
        url: "users-list",
        globalUrl: "/panel/users-list",
        name: "کاربران",
        icon: 'ic-users',
        accessRole: [AdminRoles.READ_USERS_LIST.role]
    },
    UserInformation: {
        key: "USERS_INFORMATION",
        url: "user-information/:id",
        globalUrl: "/panel/user-information/:id",
        name: "اطلاعات کاربر",
        icon: '',
        accessRole: []
    },
    UsersStatistics: {
        key: "USERS_STATISTICS",
        url: "users-statistics",
        globalUrl: "/panel/users-statistics",
        name: "آمار کاربران",
        icon: '',
        accessRole: []
    },
    UsersAvatar: {
        key: "USERS_AVATAR",
        url: "users-avatar",
        globalUrl: "/panel/users-avatar",
        name: "آواتار",
        icon: 'ic-users',
        accessRole: [AdminRoles.READ_USERS_LIST.role]
    },
    PredefinedAvatarDetails: {
        key: "PREDEFINED_AVATAR_DETAILS",
        url: "predefined-avatar-details/:id",
        globalUrl: "/panel/predefined-avatar-details/:id",
        name: "جزئیات آواتار",
        icon: 'ic-users',
        accessRole: [AdminRoles.READ_USERS_LIST.role]
    },
    UsersFileManager: {
        key: "USERS_FILE_MANAGER",
        url: "users-file-manager",
        globalUrl: "/panel/users-file-manager",
        name: "فایل ها",
        icon: 'ic-users',
        accessRole: [AdminRoles.READ_USERS_LIST.role]
    },
    ReleaseDocuments: {
        key: "RELEASE_DOCUMENTS",
        url: "release-documents",
        globalUrl: "/panel/release-documents",
        name: "اسناد انتشار",
        icon: 'ic-game-play',
        accessRole: []
    },
    Profile: {
        key: "PROFILE",
        url: "profile",
        globalUrl: "/panel/profile",
        name: "حساب کاربری",
        icon: 'magazine-icon',
        accessRole: []
    },

    SignIn: {
        url: "panel/signIn/*",
        globalUrl: "/panel/signIn",
        name: "ورود",
        icon: '',
        accessRole: []
    },
    NotAccess: {
        url: "panel/notAccess",
        globalUrl: "/panel/notAccess",
        name: "عدم دسترسی",
        icon: '',
        accessRole: []
    },


    SignInEnterPhoneNumber: {
        url: "enter-phone-number",
        globalUrl: "/panel/signIn/enter-phone-number",
        name: "ورود | ثبت نام",
        icon: '',
        accessRole: []
    },

    FILE_MANAGER: {
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: 'ic-file',
        accessRole: []
    },
    Files: {
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    SignInForgetPassword: {
        url: "forget-password",
        globalUrl: "/panel/signIn/forget-password",
        name: "فراموشی رمز عبور",
        icon: '',
        accessRole: []
    },
    AppVersionList: {
        url: "app-version-list",
        globalUrl: "/panel/app-version-list",
        name: "نسخه ها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.READ_ANDROID_RELEASES_LIST.role]
    },
    SignInEnterSubmitCode: {
        url: "enter-submit-code",
        globalUrl: "/panel/signIn/enter-submit-code",
        name: "کد تایید",
        icon: '',
        accessRole: []
    },
    SignInRefreshPassword: {
        url: "refresh-password",
        globalUrl: "/panel/signIn/refresh-password",
        name: "فراموشی رمز عبور",
        icon: '',
        accessRole: []
    },


    Habitation: {
        key: "HABITATION",
        name: "اسکان",
        icon: 'ic_residence',
        accessRole: [
            AdminRoles.READ_CLERKS_LIST.role,
            AdminRoles.READ_ACCOMMODATION_HOSTS_LIST.role,
            AdminRoles.READ_ACCOMMODATION_PERIODS_LIST.role,
            AdminRoles.READ_ACCOMMODATION_RESERVATION_PROVINCES_POPULATION_STATISTICAL.role
        ]
    },
    Residences: {
        url: "residences",
        globalUrl: "/panel/residences",
        name: "اقامتگاه ها",
        icon: '',
        accessRole: [AdminRoles.READ_ACCOMMODATION_HOSTS_LIST.role]
    },
    ResidenceDetail: {
        url: "residences/:id",
        globalUrl: "/panel/residences/:id",
        name: "اقامتگاه",
        icon: '',
        accessRole: []
    },
    ResidencesManager: {
        url: "residences-managers",
        globalUrl: "/panel/residences-managers",
        name: "خدام",
        icon: '',
        accessRole: [AdminRoles.READ_CLERKS_LIST.role]
    },
    ResidencesManagerInfo: {
        url: "residences-manager-info/:id",
        globalUrl: "/panel/residences-manager-info/:id",
        name: "اطلاعات خادم",
        icon: '',
        accessRole: []
    },
    HabitationList: {
        url: "habitation",
        globalUrl: "/panel/habitation",
        name: "اسکان دهی",
        icon: '',
        accessRole: [AdminRoles.READ_ACCOMMODATION_PERIODS_LIST.role]
    },
    HabitationReports: {
        url: "habitation/reports",
        globalUrl: "/panel/habitation/reports",
        name: "نظارت",
        icon: '',
        accessRole: [AdminRoles.READ_ACCOMMODATION_RESERVATION_PROVINCES_POPULATION_STATISTICAL.role]
    },
    PeriodList: {
        url: "habitation/period-list",
        globalUrl: "/panel/habitation/period-list",
        name: "اسکان دهی",
        icon: '',
        accessRole: [AdminRoles.READ_ACCOMMODATION_PERIODS_LIST.role]
    },
    PeriodDetails: {
        url: "habitation/period-list/:id",
        globalUrl: "/panel/habitation/period-list/:id",
        name: "جزئیات اسکان دهی",
        icon: '',
        accessRole: [AdminRoles.READ_ACCOMMODATION_PERIODS_LIST.role]
    },

    MawakibManager: {
        key: "MAWAKIB_MANAGER",
        name: "مواکب",
        icon: 'ic-ambulance',
        accessRole: [
            AdminRoles.READ_MAWKIB_PERIODS_LIST.role
        ]
    },
    MawakibManagerList: {
        key: "MAWAKIB_LIST",
        url: "mawakib-list",
        globalUrl: "/panel/mawakib-list",
        name: "دوره های ثبت نام",
        icon: "",
        accessRole: [AdminRoles.READ_MAWKIB_PERIODS_LIST.role]
    },
    MawakibServiceList: {
        key: "MAWAKIB_SERVICE_LIST",
        url: "mawakib-service-list",
        globalUrl: "/panel/mawakib-service-list",
        name: "خدمات",
        icon: "",
        accessRole: [AdminRoles.READ_MAWKIB_PERIODS_LIST.role]
    },
    MawakibServiceDetails: {
        key: "MAWAKIB_SERVICE_DETAILS",
        url: "mawakib-service-details/:id",
        globalUrl: "/panel/mawakib-service-details/:id",
        name: "جزئیات خدمت",
        icon: "",
        accessRole: []
    },
    MawakibDetails: {
        key: "MAWAKIB_DETAILS",
        url: "mawakib-details/:id",
        globalUrl: "/panel/mawakib-details/:id",
        name: "جزئیات موکب",
        icon: "ic-game-play",
        accessRole: []
    },
    MawkibRegistrationLicense: {
        key: "MAWAKIB_REGISTRATION_LICENSE",
        url: "mawakib-registration-licence",
        globalUrl: "/panel/mawakib-registration-licence",
        name: "مجوز",
        icon: "",
        accessRole: [AdminRoles.READ_MAWKIB_PERIODS_LIST.role]
    },
    MawakibLicenseDetails: {
        key: "MAWAKIB_LICENSE_DETAILS",
        url: "mawakib-license-details/:id",
        globalUrl: "/panel/mawakib-license-details/:id",
        name: "جزئیات مجوز",
        icon: "ic-game-play",
        accessRole: []
    },
    MawakibRegistrationLocation: {
        key: "MAWAKIB_REGISTRATION_LOCATION",
        url: "mawakib-registration-location",
        globalUrl: "/panel/mawakib-registration-location",
        name: "مکان ها",
        icon: "",
        accessRole: [AdminRoles.READ_MAWKIB_PERIODS_LIST.role]
    },
    MawakibLocationDetails: {
        key: "MAWAKIB_LOCAation_DETAILS",
        url: "mawakib-location-details/:id",
        globalUrl: "/panel/mawakib-location-details/:id",
        name: "جزئیات مکان موکب",
        icon: "ic-game-play",
        accessRole: []
    },
    Tourism: {
        key: "TOURISM",
        name: "گردشگری",
        icon: "ic-camp",
        accessRole: [AdminRoles.READ_LOCATIONS_LIST.role, AdminRoles.READ_LOCATION_CATEGORY_TREE.role, AdminRoles.READ_LOCATION_CATEGORIES_META_DATA_REPORTS.role]
    },
    TourismPlaceList: {
        url: "tourism-place-list",
        globalUrl: "/panel/tourism-place-list",
        name: "مکان ها",
        icon: "ic-camp",
        accessRole: [AdminRoles.READ_LOCATIONS_LIST.role]
    },
    TourismPlaceDetail: {
        url: "tourism-place/:id",
        globalUrl: "/panel/tourism-place/:id",
        name: "جزئيات مکان",
        icon: "ic-camp",
        accessRole: [AdminRoles.READ_LOCATIONS_LIST.role]
    },
    TourismCategory: {
        url: "tourism_category",
        globalUrl: "/panel/tourism_category",
        name: "دسته بندی ها",
        icon: "ic-camp",
        accessRole: [AdminRoles.READ_LOCATION_CATEGORY_TREE.role]
    },
    TourismReport: {
        url: "tourism_report",
        globalUrl: "/panel/tourism_report",
        name: "گزارش گیری",
        icon: "ic-camp",
        accessRole: [AdminRoles.READ_LOCATION_CATEGORIES_META_DATA_REPORTS.role]
    },
    Campaigns: {
        url: "campaigns",
        globalUrl: "/panel/campaigns",
        name: "پویش ها",
        icon: "ic-camp",
        accessRole: [AdminRoles.READ_LOCATION_CATEGORIES_META_DATA_REPORTS.role]
    },
    CampaignDetails: {
        url: "campaign-details/:id",
        globalUrl: "/panel/campaign-details/:id",
        name: "جزئيات پویش",
        icon: "ic-camp",
        accessRole: [AdminRoles.READ_LOCATION_CATEGORIES_META_DATA_REPORTS.role]
    },
    WorkAndBusiness: {
        url: "work_and_business",
        globalUrl: "/panel/work_and_business",
        name: "کار و کسب ها",
        icon: "ic-camp",
        accessRole: [AdminRoles.READ_LOCATION_CATEGORIES_META_DATA_REPORTS.role]
    },
    Vow: {
        key: "VOW",
        name: "نذورات",
        icon: "ic-donation",
        accessRole: [AdminRoles.READ_VOWS_LIST.role, AdminRoles.READ_VOW_STATISTICAL_SUMMARY.role,]
    },
    VowList: {
        url: "vow-list",
        globalUrl: "/panel/vow-list",
        name: "نذورات",
        icon: "ic_wallet_money",
        accessRole: [AdminRoles.READ_VOWS_LIST.role]
    },
    VowPayments: {
        url: "vow-payments",
        globalUrl: "/panel/vow-payments",
        name: "پرداخت ها",
        icon: "ic_card_pos",
        accessRole: [AdminRoles.READ_VOW_STATISTICAL_SUMMARY.role]
    },
    VowDetail: {
        url: "vow-list/:id",
        globalUrl: "/panel/vow-list/:id",
        name: "جزئیات نذر",
        icon: "ic_wallet_money",
        accessRole: []
    },

    Android: {
        key: "ANDROID",
        name: "اندروید",
        icon: 'ic_android_2',
        accessRole: [AdminRoles.READ_OCCASIONAL_BANNER_LIST.role, AdminRoles.UPDATE_ANDROID_RELEASE.role, AdminRoles.READ_ANDROID_RELEASES_LIST.role]
    },
    OccasionalBanner: {
        url: "occasional_banner",
        globalUrl: "/panel/occasional_banner",
        name: "بنر مناسبتی",
        icon: "ic-android'",
        accessRole: [AdminRoles.READ_OCCASIONAL_BANNER_LIST.role]
    },

    AppVersionDetail: {
        url: "app-version/:id",
        globalUrl: "/panel/app-version/:id",
        name: "جزئيات نسخه",
        icon: "ic-game-play",
        accessRole: [AdminRoles.UPDATE_ANDROID_RELEASE.role]
    },
    OccasionalBannerDetail: {
        url: "occasional_banner/:id",
        globalUrl: "/panel/occasional_banner/:id",
        name: "جزئیات بنر مناسبتی",
        icon: "ic-game-play",
        accessRole: [AdminRoles.CREATE_ADMIN_ROLE.role]
    },
    Settings: {
        key: "SETTINGS",
        name: "تنظیمات",
        icon: 'ic_setting',
        accessRole: [AdminRoles.UPDATE_ACCOMMODATION_PERIOD_AUTOMATIC_ACCEPTANCE.role, AdminRoles.READ_LANGUAGES_LIST.role]
    },
    HabitationSettings: {
        url: "habitation_setting",
        globalUrl: "/panel/habitation_setting",
        name: "اسکان",
        icon: "",
        accessRole: [AdminRoles.UPDATE_ACCOMMODATION_PERIOD_AUTOMATIC_ACCEPTANCE.role]
    },
    LanguageSetting: {
        url: "language_setting",
        globalUrl: "/panel/language_setting",
        name: "زبان ها",
        icon: "",
        accessRole: [AdminRoles.READ_LANGUAGES_LIST.role]
    },
    //Etekaf
    EtekafManagerList: {
        key: "ETEKAF_LIST",
        url: "etekaf-list",
        globalUrl: "/panel/etekaf-list",
        name: "اعتکاف",
        icon: "ic_residence",
        accessRole: [AdminRoles.READ_ITIKAF_PERIOD_INFORMATION.role]
    },
    EtekafDetails: {
        key: "ETEKAF_DETAILS",
        url: "etekaf-details/:id",
        globalUrl: "/panel/etekaf-details/:id",
        name: "جزئیات موکب",
        icon: "",
        accessRole: [AdminRoles.READ_ITIKAF_PERIOD_INFORMATION.role]
    },
    CompleteRegistration: {
        url: "panel/complete-registration",
        globalUrl: "/panel/complete-registration",
        name: "تکمیل فرآیند ثبت نام",
        icon: '',
        accessRole: []
    },
    Game: {
        key: "GAME",
        name: "نسل آرمانی",
        icon: 'ic-game-play',
        accessRole: []
    },
    GamePeriod: {
        key: "GAME_PERIOD",
        url: "game-period",
        globalUrl: "/panel/game-period",
        name: "دوره برگزاری",
        icon: "",
        accessRole: []
    },
    GamePeriodDetails: {
        key: "GAME_PERIOD_DETAILS",
        url: "game-period/:gamePeriodId",
        globalUrl: "/panel/game-period/:gamePeriodId",
        name: "جزئیات دوره برگزاری",
        icon: "",
        accessRole: []
    },
    Games: {
        key: "GAMES",
        url: "games",
        globalUrl: "/panel/games",
        name: "بازیها",
        icon: "",
        accessRole: []
    },
    GameDetails: {
        key: "GAME_DETAILS",
        url: "game-details/:id",
        globalUrl: "/panel/game-details/:id",
        name: "جزئیات بازی",
        icon: "ic-menu",
        accessRole: []
    },
    GameStageDetails: {
        key: "GAME_STAGE_DETAILS",
        url: "game-details/:gameId/game-stage/:gameStageId",
        globalUrl: "/panel/game-details/:gameId/game-stage/:gameStageId",
        name: "جزئیات مرحله",
        icon: "ic-menu",
        accessRole: []
    },
    GameRegistrantInformation: {
        key: "GAME_REGISTRANT_INFORMATION",
        url: "game-period/:gamePeriodId/game-registrant-information/:registrantId",
        globalUrl: "/panel/game-period/:gamePeriodId/game-registrant-information/:registrantId",
        name: "اطلاعات ثبت نام کننده",
        icon: "ic-menu",
        accessRole: []
    },
    GameTeamDetails: {
        key: "GAME_TEAM_DETAILS",
        url: "game-period/:gamePeriodId/game-team/:gameTeamId",
        globalUrl: "/panel/game-period/:gamePeriodId/game-team/:gameTeamId",
        name: "جزئیات تیم",
        icon: "ic-menu",
        accessRole: []
    },
}


